import { IIdItemInfo, INamedItemInfo, ILuidItemInfo } from './resourceInfoParts';

export enum LocationTypes {
  Project,
  PersonalSpace,
  Unknown
}

export interface ILocationInfo extends IIdItemInfo, INamedItemInfo, ILuidItemInfo{
  type: LocationTypes;
}
